import { Component, OnInit } from '@angular/core';

import { tap } from 'rxjs';
import { config } from 'src/app/config/api.config';
import { DocumentType } from 'src/app/model/documentType.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Utilisateur } from 'src/app/model/userPostgres.model';
import { UtilisateursService } from '../../services/utilisateurs.service';
import { DocumentDetails } from 'src/app/model/documentDetails.model';
import { Router } from '@angular/router';
import { BreadcrumbItem } from 'src/app/modules/shared/components/breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-portfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.css'],
})
export class PortfolioComponent implements OnInit {
  formDocument!: FormGroup;
  maxFileSize: number = 5120000;
  user: any;
  fileSize!: number;
  fileName!: string;
  IUF_apprenant!: string;
  file: File | null = null; // Variable to store file
  documentsList: any[] = [];
  url: string = config.openBaseUrl;
  popupVisible: boolean = false;
  classOpen: string = '';
  documentType: any[] = DocumentType.List;
  isForAddDocument: boolean = false;
  isForUpdateDocument: boolean = false;
  diplomeId!: number;
  diplomeName: string = '';

  documentDetails!: DocumentDetails;
  diplomes!: any[];

  constructor(
    private service: UtilisateursService,
    private formBuilder: FormBuilder,
    private router: Router
  ) {
    this.user = sessionStorage.getItem('user');
    this.IUF_apprenant = JSON.parse(this.user).iuf;
    // console.log('User connecte', JSON.parse(this.user));

    this.formDocument = this.formBuilder.group({
      documentType: ['', Validators.required],
      nomdiplome: ['', Validators.required],
      dateobtention: ['', Validators.required],
      etablissement: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.service
      .getApprenantDocuments(this.IUF_apprenant)
      .pipe(
        tap((response) => {
          this.documentsList = response.object;
        })
      )
      .subscribe();

    this.service
      .getMyPorfolio(this.IUF_apprenant)
      .pipe(
        tap((portfolio) => {
          this.diplomes = portfolio.object.diplomes;
        })
      )
      .subscribe();
  }

  // On file Select
  onChange(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      this.file = file;
      this.fileSize = file.size;
      this.fileName = file.name;
      //// //console.log(this.file.name);
    }
  }

  onUpload() {
    const formSelectedData = this.formDocument.value;
    const documentType = formSelectedData['documentType'];

    let datepart = JSON.stringify(formSelectedData['dateobtention']);
    //// //console.log(datepart);
    const newDate = new Date(datepart);
    //// //console.log(newDate);

    if (this.file && documentType) {
      const formData = new FormData();

      const details = new DocumentDetails(
        newDate,
        formSelectedData['documentType'],
        formSelectedData['etablissement'],
        formSelectedData['nomdiplome']
      );
      formData.append('file', this.file);
      formData.append('options', JSON.stringify(details));

      this.service.uploadFileToAlfresco(formData, this.IUF_apprenant).subscribe(
        (response) => {
          //// //console.log(response, 'File uploaded successfully');
          if (response.status == 200) {
            this.reloadPage();
            this.popupVisible = false;
          }
        },
        (error) => {
          console.error('Error uploading file:', error);
        }
      );
    }
  }

  reloadPage() {
    const currentRoute = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentRoute]);
    });
  }
 
  togglePopup() {
    this.diplomeName = '';
    if (this.classOpen === '') {
      this.popupVisible = !this.popupVisible;
      this.classOpen = 'open';
      this.isForUpdateDocument = false;
      this.isForAddDocument = true;
    } else if (this.classOpen === 'open') {
      this.popupVisible = !this.popupVisible;
      this.classOpen = '';
      this.isForAddDocument = false;
      this.isForUpdateDocument = true;
    }
  }
  togglePopupForUpdate(diplome_id: number, diplomeName: string) {
    this.diplomeId = diplome_id;
    this.diplomeName = diplomeName;

    if (this.classOpen === '') {
      this.popupVisible = !this.popupVisible;
      this.classOpen = 'open';
      this.isForUpdateDocument = true;
      this.isForAddDocument = false;
    } else if (this.classOpen === 'open') {
      this.popupVisible = !this.popupVisible;
      this.classOpen = '';
      this.isForAddDocument = true;
      this.isForUpdateDocument = false;
    }
  }

  onDeleteDocuments(nodeId: string) {
    this.service.deleteDocument(nodeId).subscribe((Response) => {
      if (Response === 'NO_CONTENT') {
        this.service
          .getApprenantDocuments(this.IUF_apprenant)
          .pipe(
            tap((response) => {
              this.documentsList = response.object;
              //// //console.log(this.documentsList);
            })
          )
          .subscribe();
        //// //console.log(Response);

        this.service
          .getMyPorfolio(this.IUF_apprenant)
          .pipe(
            tap((portfolio) => {
              this.diplomes = portfolio.object.diplomes;
            })
          )
          .subscribe();
      }
    });
  }

  onDeleteDiplome(diplome_id: number) {
    this.service
      .deleteDiplome(diplome_id)
      .pipe(
        tap((response) => {
          if (response === 'OK') {
            this.service
              .getApprenantDocuments(this.IUF_apprenant)
              .pipe(
                tap((response) => {
                  this.documentsList = response.object;
                  //// //console.log(this.documentsList);
                })
              )
              .subscribe();
            //// //console.log(Response);

            this.service
              .getMyPorfolio(this.IUF_apprenant)
              .pipe(
                tap((portfolio) => {
                  this.diplomes = portfolio.object.diplomes;
                })
              )
              .subscribe();
          }
        })
      )
      .subscribe();
  }

  onUpdate() {
    const formSelectedData = this.formDocument.value;
    const documentType = formSelectedData['documentType'];

    let datepart = JSON.stringify(formSelectedData['dateobtention']);
    const newDate = new Date(datepart);

    if (this.file && documentType) {
      const formData = new FormData();

      const details = new DocumentDetails(
        newDate,
        formSelectedData['documentType'],
        formSelectedData['etablissement'],
        formSelectedData['nomdiplome']
      );
      formData.append('file', this.file);
      formData.append('options', JSON.stringify(details));
      this.service
        .updateDiplome(formData, this.diplomeId, this.IUF_apprenant)
        .subscribe(
          (Response) => {
            //// //console.log(Response, 'File uploaded successfully');
            if (Response.status == 200) {
              this.reloadPage();
            }
          },
          (error) => {
            console.error('Error uploading file:', error);
          }
        );

      // this.service.uploadFileToAlfresco(formData, this.IUF_apprenant).subscribe(
      //   (response) => {
      //     //// //console.log(response, 'File uploaded successfully');
      //     if (response.status == 200) {
      //       this.reloadPage();
      //     }
      //   },
      //   (error) => {
      //     console.error('Error uploading file:', error);
      //   }
      // );
    }
  }

  breadcrumbItems: BreadcrumbItem[] = [
    { label: 'OUTILS'},
    { label: 'MON PORTFOLIO', url: '/dashboard/users/portfolio'}
  ];
}
